import { useMemo } from "react";
import { useHomePage } from "../../context/HomePageContext";
import { useLanguage } from "../../context/LanguageContext";
import { resolveAboutHero } from "../../lib/homePageContent";
import "../../style/animations.css";

export default function HeroAboutUs() {
  const { data } = useHomePage();
  const { language } = useLanguage();
  const about = useMemo(() => resolveAboutHero(data?.about_hero, language), [data, language]);

  return (
    <section
      className="
        w-full
        flex
        justify-center
      ">
      <div
        className="
    relative

    w-full

    min-h-screen
    lg:min-h-[694px]

    overflow-hidden
  ">
        {/* BACKGROUND IMAGE */}
        <img
          src={about.image}
          alt="worker"
          className="
            absolute
            inset-0

            w-full
            h-full

            object-cover

            lg:left-[464px]
            lg:top-0
            lg:w-[1041px]
            lg:h-full

            animate-scale-in
          "
        />

        {/* DARK OVERLAY */}
        <div
          className="
            absolute
            inset-0

            bg-black/40

            lg:bg-black/10

            z-10
          "
        />

        {/* GRADIENT */}
        <div
          className="
            absolute
            inset-0

            bg-[linear-gradient(180deg,rgba(0,0,0,0.55)_0%,rgba(61,164,168,0.65)_100%)]

            lg:bg-[linear-gradient(270.22deg,rgba(61,164,168,0)_32.94%,#3DA4A8_58.71%)]

            z-10
          "
        />

        {/* CONTENT */}
        <div
          className="
    relative
    z-20

    h-full

    px-6
    pt-32
    pb-20

   lg:pt-[130px]
    lg:pl-[78px]
  ">
          <div
            className="
              w-full
              max-w-[573px]

              text-white
            ">
            {/* SUBTITLE */}
            {/* <span
              className="
                text-[20px]

                block
                mb-4

                lg:text-[24px]
                lg:mb-6
              ">
              Tentang Kami
            </span> */}

            {/* TITLE */}
            <h1
              style={{ animationDelay: "0.1s" }}
              className="
                text-[52px]
                leading-[60px]

                font-bold

                mb-8

               lg:text-[64px]
                lg:leading-[76px]
                lg:mb-10

                animate-fade-in-up
              ">
              {about.title}
            </h1>

            {/* DESCRIPTION (Enter di admin = paragraf baru) */}
            {about.paragraphs.map((paragraph, index) => {
              const isLast = index === about.paragraphs.length - 1;

              return (
                <p
                  key={index}
                  style={{ animationDelay: `${(0.3 + index * 0.15).toFixed(2)}s` }}
                  className={`
                    text-[16px]
                    leading-[34px]

                    ${isLast ? "" : "mb-6 lg:mb-8"}

                    lg:text-[18px]
                    lg:leading-[34px]

                    animate-fade-in-up
                  `}>
                  {paragraph}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
